import { Button, Chip, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { variants } from '../../../../variants/variants';
import UserAvatar from '../../../../common/UserAvatar';
import { Box } from '@mui/material';
import { ArrowRightAltRounded, CheckOutlined, ManageHistoryOutlined, People } from '@mui/icons-material';
import { boxBackground, colors } from '../../utility/status';
import { useTheme } from '@emotion/react';
import SwipeEdge from '../../../../common/SwipeEdge';

const CustomRow = ({ gift, handleOpenDialog, handleOpenChangeDialog, result }) => {
  const id = gift[0];
  const currentDesignation = gift[2]?.split(' - ')[0];
  const desiredDesignation = gift[3]?.split(' - ')[0];
  const submitted = gift[5];
  const status = gift[4]?.split('_').join(' ');
  const theme = useTheme();

  return (
    <>
      <Stack direction={'row'} alignItems={'center'} sx={{ border: 0 }}>
        <UserAvatar src={gift[1]?.employeePhotoPath} />
        <Box sx={{ mr: 'auto', ml: 2 }}>
          <Typography sx={{ fontSize: variants.BODY, mb: 0.5 }}>{gift[1]?.empName}</Typography>
          <Stack direction={'row'} alignItems={'center'} sx={{ mb: 0.5 }}>
            <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>
              {currentDesignation}
            </Typography>
            <ArrowRightAltRounded />
            <Typography sx={{ fontSize: variants.TINY, color: variants.typography.active.main }}>
              {desiredDesignation}
            </Typography>
          </Stack>
          <Typography sx={{ fontSize: variants.TINY, mb: 0.5 }}>{new Date(submitted).toLocaleDateString()}</Typography>
        </Box>

        {result === 'Pending' ? (
          <Stack sx={{ ml: 'auto' }}>
            <Button
              startIcon={<ManageHistoryOutlined />}
              size='small'
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenChangeDialog(id);
              }}
              sx={{
                color: colors.Pending,
                fontSize: variants.TINY,
              }}
            >
              Revert
            </Button>

            <Button
              startIcon={<CheckOutlined />}
              size='small'
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                handleOpenDialog(id);
              }}
              sx={{
                color: colors.Pass,
                fontSize: variants.TINY,
              }}
            >
              Approve
            </Button>
          </Stack>
        ) : (
          <Chip
            variant='outlined'
            sx={{ ml: 'auto', background: boxBackground[status], border: 0, color: colors[status], fontWeight: 700 }}
            label={status}
          />
        )}
      </Stack>
      {/* <SwipeEdge drawerBleeding={0} /> */}
    </>
  );
};
export default CustomRow;
